export const getPartAdjustments = (state) => {
  return state.partAdjustments;
};
